import { LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutSalesJournalReport } from "./autogen/AutogenLayoutSalesJournalReport";

export class SalesJournalReport extends AutogenLayoutSalesJournalReport {
    override onLoad(): void {
        this.textboxReportType.selectedItem = this.textboxReportType.items[0];
    }

    textboxCustomersBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = "Y"
        event.filter.type_of = "C"
    }
}
